import { PageTypeEnum } from '@/constant';
import { NOOP } from '@/utils';

export const getScreenData: {
	[key in PageTypeEnum | string]: {
		title: string;
		desc1: string;
		desc2: string;
		desc3: string;
		desc4: string;
		templateName: string;
	};
} = {
	[PageTypeEnum.APPLICANT]: {
		title: '근로자 추가/업데이트 (엑셀)',
		desc1:
			'엑셀 파일로 근로자를 일괄 추가하거나, 이미 추가된 근로자를 업데이트 할 수 있습니다.',
		desc2: '업데이트 시, ',
		desc3: '이전 근로자 정보를 복구할 수 없습니다.',
		desc4: '현재 근로자 정보를 다운 받아 놓으세요.',
		templateName: ' 현재 근로자 정보 다운로드',
	},
	[PageTypeEnum.FRANCHISE]: {
		title: '사업장 추가/업데이트 (엑셀)',
		desc1:
			'엑셀 파일로 사업장를 일괄 추가하거나, 이미 추가된 사업장 정보를 업데이트 할 수 있습니다.',
		desc2: '업데이트 시, ',
		desc3: '이전 사업장 정보를 복구할 수 없습니다.',
		desc4: '현재 사업장 정보를 다운 받아 놓으세요.',
		templateName: ' 현재 사업장 정보 다운로드',
	},
	[PageTypeEnum.RECOMMENDER]: {
		title: '추천자 추가/업데이트 (엑셀)',
		desc1:
			'ID를 입력하지 않은 경우 추천자가 일괄 추가 되고, \n ID가 동일한 경우 동일한 추천자로 확인되어 정보가 업데이트됩니다.',
		desc2: '업데이트 시, ',
		desc3: '이전 추천자 정보를 복구할 수 없습니다.',
		desc4: '현재 추천자 정보를 다운 받아 놓으세요.',
		templateName: ' 현재 추천자 정보 다운로드',
	},
	[PageTypeEnum.LODGING]: {
		title: '숙소 추가/업데이트 (엑셀)',
		desc1:
			'엑셀 파일로 선택한 사업장에 근로자를 배정하거나, 이미 배정된 정보를 업데이트 할 수 있습니다.',
		desc2: '업데이트 시, ',
		desc3: '이전 배정 정보를 복구할 수 없습니다.',
		desc4: '현재 숙소 정보를 다운 받아 놓으세요.',
		templateName: ' 현재 숙소 정보 다운로드',
	},
	[PageTypeEnum.ASSIGNMENT]: {
		title: '일반(농가) 배정 (엑셀)',
		desc1: '엑셀 파일로 일반(농가) 배정 정보를 등록할 수 있습니다.',
		desc2: '업데이트 시, ',
		desc3: '이전 배정 정보를 복구할 수 없습니다.',
		desc4: '현재 배정 정보를 다운 받아 놓으세요.',
		templateName: ' 현재 배정 정보 다운로드',
	},
	[PageTypeEnum.PUBLIC_ASSIGNMENT]: {
		title: '공공형 배정 (엑셀)',
		desc1: '엑셀 파일로 공공형 배정 정보를 등록할 수 있습니다.',
		desc2: '업데이트 시, ',
		desc3: '이전 배정 정보를 복구할 수 없습니다.',
		desc4: '현재 배정 정보를 다운 받아 놓으세요.',
		templateName: ' 현재 배정 정보 다운로드',
	},
};

export const TriggerUploadExcelClick = {
	show: NOOP,
};
